
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"24 / preview"}},[_c('path',{attrs:{"id":"24 / preview cart","d":"M23.3546 24L26.056 26.6128M8.60471 18.6H4.8074C4.09406 18.5869 3.48341 18.0847 3.33262 17.3872L1.05274 7.7872C0.929479 7.3216 1.02485 6.82519 1.31186 6.43845C1.59887 6.05172 2.0463 5.81673 2.52752 5.8H21.8798C22.3609 5.81713 22.8081 6.05221 23.095 6.43883C23.3819 6.82546 23.4774 7.32163 23.3546 7.7872L23.0347 9.12693M4.20597 5.8L9.00459 1M20.2014 5.8L15.4028 1.00213M25 18.6C25 22.1346 22.1354 25 18.6018 25C15.0682 25 12.2037 22.1346 12.2037 18.6C12.2037 15.0654 15.0682 12.2 18.6018 12.2C22.1354 12.2 25 15.0654 25 18.6Z","stroke":"currentColor","stroke-width":"1.92","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    